// extracted by mini-css-extract-plugin
export var activeDot = "_45-c";
export var buttonContainer = "_45-9";
export var channelButton = "_45-a";
export var clickable = "_45-d";
export var content = "_45-0";
export var contentFull = "_45-2";
export var contentThird = "_45-1";
export var contentWrapper = "_45-7";
export var description = "_45-5";
export var heightShort = "_45-f";
export var image = "_45-3";
export var imageContainer = "_45-4";
export var selectButton = "_45-e";
export var spinnerContainer = "_45-b";
export var titleContent = "_45-8";
export var titleWrapper = "_45-6";